import type { Resource } from '../../';
export const general_errors_bodyMessage2: Resource = {"default":"If you feel you have reached this page by mistake, please verify the web address and try again."};
